import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../theme';

/**
 * Custom hook that defines the styles for the login component.
 */
const useLoginStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: 'rgb(193, 211, 252)',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontFamily: theme.fontFamily,
    textAlign: 'center',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.padding.m,
    backgroundColor: theme.background.paper,
    padding: theme.padding.l,
    margin: theme.margin.l,
    borderRadius: theme.borderRadius.m,
    width: '30vw',
  },
  labelText: {
    fontFamily: theme.fontFamily,
    margin: theme.margin.s,
    padding: 0,
  },
  formInput: {
    marginBottom: theme.margin.m,
    maxWidth: 'none',
    width: '100%',
  },
  submitButton: {
    width: '100%',
    margin: 0,
    marginTop: theme.margin.m,
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  switchButton: {
    'width': '100%',
    'backgroundColor': colors.green[400],
    'border': `1px solid ${colors.green[400]}`,
    'margin': 0,
    'marginBottom': theme.margin.m,
    '&:hover': {
      backgroundColor: colors.green[500],
      borderColor: colors.green[500],
    },
    '&:active': {
      backgroundColor: colors.green[600],
      boxShadow: theme.buttonShadow(colors.green[600]),
      borderColor: colors.green[600],
    },
  },
  dividerOr: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.gap.s,
    margin: `${theme.margin.l} 0 ${theme.margin.m} 0`,
  },
  dividerLine: {
    width: '100%',
    border: theme.border,
  },
  dividerText: {
    color: colors.gray['400'],
  },
  welcome: {
    marginTop: theme.margin.l,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorMessage: {
    fontFamily: theme.fontFamily,
    color: colors.red['400'],
    marginBottom: theme.margin.m,
    fontSize: theme.fontSize.default,
    marginTop: theme.margin.xs,
    fontWeight: theme.fontWeight.medium,
    marginLeft: theme.margin.xs,
  },
  logo: {
    height: '60px',
    transform: 'translateY(2px)',
  },
}));

export default useLoginStyles;
